import { render, staticRenderFns } from "./OrderFieldIssue.vue?vue&type=template&id=3e2be856"
import script from "./OrderFieldIssue.vue?vue&type=script&lang=js"
export * from "./OrderFieldIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports